import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { CardItem } from '@europrocurement/flexy-components';
import { SignableDocument } from '../../../../providers/types';

export type DocumentsCollectionProps = {
    documents: Array<SignableDocument>;
};

const DocumentsCollection: React.FunctionComponent<DocumentsCollectionProps> = function (props) {
    const { documents } = props;
    const { palette } = useTheme();

    return (
        <>
            <Typography variant="l2dh7">
                {documents.length > 1 ? 'Documents' : 'Document'}
            </Typography>
            {documents.map((document) => (
                <CardItem
                    key={`${document.documentName}`}
                    title={document.documentName}
                    additionalInfos={document.documentFileName ? [document.documentFileName] : []}
                    color={palette.primary}
                    icon="file"
                />
            ))}
        </>
    );
};

export default DocumentsCollection;
